import * as React from 'react';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Tooltip from '@mui/material/Tooltip';
import { GridFilterPanel } from '@mui/x-data-grid-pro';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import Zoom from '@mui/material/Zoom';
import ReplayIcon from '@mui/icons-material/Replay';
import { InvoiceDocumentEditor } from '../InvoiceDocument/InvoiceDocumentEditor';
import { Constants } from '../Common/Constants';
import Link from '@mui/material/Link';
import { toast } from 'react-toastify';
import { httpGet, httpPost } from '../../HttpRequestHandling/httpRequestHandler';
import { formatNumber, splitByUppercase, stringIsNullOrEmpty, downloadInvoiceFile, getFileIcon, getDisplayName } from '../Common/Utilities';
import EnhancedDataGrid from '../Common/EnhancedDataGrid';
import ServerExportWrapper from '../Common/DataGridServerExportWrapper';
import { MUIButton } from '../Common/Components/MuiButton';
import { useGridApiContext, GridFilterInputSingleSelect, getGridSingleSelectOperators, getGridNumericOperators } from '@mui/x-data-grid';
import { getFilter, setFilter } from '../Common/Utilities';
import { Check } from '@mui/icons-material';
import RemoveIcon from '@mui/icons-material/Remove';
import { CopyableCell } from '../Common/Components/CopyableCell';

import { Checkbox, CircularProgress, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, InputLabel, ListItemText } from "@mui/material";

const numberFilterOperators = getGridNumericOperators().map((op) => {
	const labelMap = {
		'=': 'is equal to',
		'!=': 'is not equal to',
		'>': 'is greater than',
		'>=': 'is greater than or equal to',
		'<': 'is less than',
		'<=': 'is less than or equal to',
		'isEmpty': 'is empty',
		'isNotEmpty': 'is not empty',
	};
	return { ...op, label: labelMap[op.value] ?? op.label };
});

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Zoom in={true} ref={ref} {...props} />;
});
// 🔽 ADD THIS FUNCTION BEFORE your component class

export default class VendorInvoicesReport extends React.Component {
	constructor() {
		super();
		const persisted = getFilter(['Reports', 'VendorInvoicesReport']) || {};
		var userInfo = JSON.parse(localStorage["userInfo"]);
		var authUserInfo = JSON.parse(localStorage.authenticatedUser);
		this.resourceId = userInfo?.id;
		this.companyCode = userInfo?.companyCode || 0;
		var modelDefId = persisted.modelDefId ?? this.getDefaultModelDefId(userInfo);
		var companiesList = authUserInfo?.authenticatedUserInfoList || [];
		var selectedCompanies = persisted.selectedCompanies;

		const nineWeeksAgo = new Date();
		nineWeeksAgo.setDate(nineWeeksAgo.getDate() - 63);

		const defaultFilterModel = {
			items: [{
				field: 'invoiceDate',
				operator: 'after',
				value: nineWeeksAgo.toISOString().split('T')[0] // format as YYYY-MM-DD
			},
			{
				field: 'isArchive',
				operator: 'is',
				value: 'N',
			},
			],
			logicOperator: 'and'
		};
		let defaultCompaniesList = (selectedCompanies || []).length > 0 ?
			companiesList?.filter(e => selectedCompanies.indexOf(e.companyCode) > -1) :
			companiesList?.filter(e => e.companyCode === this.companyCode)
		this.state = {
			downloadingInvoices: {},
			data: [],
			modelDefId: modelDefId,
			userInfo: userInfo,
			taxSetting: 0,
			statusList: {},
			filterText: persisted.filterText ?? '',
			lastFilterText: '',
			columnVisibility: persisted.columnVisibility || {},
			filterModel: persisted.filterModel ?? defaultFilterModel,
			tempTableEnabled: false,
			exportData: [],
			dataLoaded: false,
			isServerMode: false,
			filteredData: [],
			hasSearched: persisted.hasSearched ?? false,
			sortModel: persisted.sortModel || [],
			defaultFilter: [
				...defaultFilterModel.items,
			],
			companyList: companiesList,
			selectedCompanies: defaultCompaniesList,
			activeRowKey: null,       // row user selected/opened (single row highlight)
			activeInvoiceDocumentId: null, // invoiceDocumentId of active row (for ops)
			loadingRowIds: [],       // invoiceDocumentIds currently refreshing (spinner for all matching rows)
			openInvoiceDocumentEditorDialog: false,
			mode: Constants?.VIEW || 'View',
			rowData: null,
			creditMemoRowForRepost: null,
			openCreditMemoRepostDialog: false,
			applyToInvoiceDocumentId: null
		};
		this.mainGridRef = React.createRef();
		this.modelDefId_changeHandler = this.modelDefId_changeHandler.bind(this);
		this.getDefaultModelDefId = this.getDefaultModelDefId.bind(this);
		this.getInvoiceTypeMenuItem = this.getInvoiceTypeMenuItem.bind(this);
		this.searchCallback = this.searchCallback.bind(this);
		//this.getSearchButton = this.getSearchButton.bind(this);
		this.getFilterItems = this.getFilterItems.bind(this);
		this.fieldInModel = this.fieldInModel.bind(this);
		this.normalizeFilterModel = this.normalizeFilterModel.bind(this);
		this.fetchCompanyList = this.fetchCompanyList.bind(this);
		this.detail_clickHandler = this.detail_clickHandler.bind(this);
		this.invoiceDocumentEditor_closeHandler = this.invoiceDocumentEditor_closeHandler.bind(this);
		this.delay = this.delay.bind(this);
		this.removeRowFromGrid = this.removeRowFromGrid.bind(this);
		this.fetchReportRowByInvoiceId = this.fetchReportRowByInvoiceId.bind(this);
		this.refreshRowViaReportApi = this.refreshRowViaReportApi.bind(this);
		this.replaceInvoiceRowByFileKey = this.replaceInvoiceRowByFileKey.bind(this);
		this.getFilterOperator = this.getFilterOperator.bind(this);
		this.resolveInvoiceStatusText = this.resolveInvoiceStatusText.bind(this);
	}

	resolveInvoiceStatusText(row, statusList) {
		if (
			row?.invoicePostStatus?.toLowerCase() === 'partial posted' &&
			row?.postedNumberInvoice > 0 &&
			row?.postedNumberInvoice < row.totalNumberInvoice
		) {
			return `Partially Posted (${row.postedNumberInvoice}/${row.totalNumberInvoice})`;
		}

		if (
			row?.invoiceDocumentStatusId === 170 &&
			Number(row?.isCmInternalyPosted) === 1
		) {
			return 'Posted (Internally)';
		}

		return statusList[row?.invoiceDocumentStatusId] ?? 'Unknown';
	}

	assignRowIds(rows) {
		let lastInvoiceId = null;
		let counter = 0;

		return rows.map(row => {
			if (row.invoiceDocumentId !== lastInvoiceId) {
				lastInvoiceId = row.invoiceDocumentId;
				counter = 1;
			} else {
				counter++;
			}

			return {
				...row,
				rowId: `${row.invoiceDocumentId}_${counter}`
			};
		});
	}

	getDefaultModelDefId(userInfo) {
		if (!stringIsNullOrEmpty(userInfo.invoiceType)) {
			if (userInfo.invoiceType.includes('1')) {
				return 1;
			}
			else if (userInfo.invoiceType.includes('2')) {
				return 2;
			}
		}
	}

	getFilterOperator(name) {
		var filter = [];
		switch (name) {
			case 'IsArchive': {
				filter = [
					{
						label: 'is',
						value: 'equals',
						getApplyFilterFn: (filterItem) => {
							if (filterItem.value === undefined || filterItem.value === null) return null;
							return (params) => params.value === filterItem.value;
						},
						InputComponent: GridFilterInputSingleSelect,
						InputComponentProps: {
							valueOptions: [
								{ value: 'N', label: 'UnArchived' },
								{ value: 'Y', label: 'Archived' },
								{ value: '', label: 'Any' },
							],
						},
					},
				];
				break;
			}
			default: {
				break;
			}
		}
		return filter;
	}

	componentDidMount() {

		const gridRef = this.mainGridRef?.current;

		const { filterModel, filterText, modelDefId, selectedCompanies: sCompanies, hasSearched } = this.state;
		gridRef.setFilterModel({
			...filterModel,
			quickFilterValues: ['']
		});
		if (gridRef && typeof gridRef.setQuickFilterValues === 'function') {
			gridRef.setQuickFilterValues([filterText]);
		}
		this.fetchVendorInvoices({
			modelDefId: modelDefId,
			filterModel: filterModel,
			companiesList: sCompanies.map(e => e.companyCode),
			searchText: hasSearched ? filterText : ''
		});
		var selectedCompanies = sCompanies.map(e => e.companyCode)
		setFilter(['Reports', 'VendorInvoicesReport'], {
			...getFilter(['Reports', 'VendorInvoicesReport']),
			hasSearched,
			filterText,
			modelDefId,
			filterModel,
			selectedCompanies,
			columnVisibility: this.state.columnVisibility
		});
	}

	handleDownloadFile = (modelDefId, rowId, fileLocation, companyCode) => {

		this.setState(prev => ({
			downloadingInvoices: {
				...prev.downloadingInvoices,
				[rowId]: true
			}
		}));

		downloadInvoiceFile(modelDefId, fileLocation, companyCode)
			.catch((error) => {

				const isNotFoundError =
					error?.response?.status === 422 ||
					error?.message === 'FILE_NOT_FOUND';

				if (isNotFoundError) {
					toast.error('File not found.');
				} else {
					toast.error('Failed to download the file.');
				}
			})
			.finally(() => {

				this.setState(prev => {
					const next = { ...prev.downloadingInvoices };
					delete next[rowId];
					return { downloadingInvoices: next };
				});
			});
	};

	modelDefId_changeHandler(event) {
		const modelDefId = parseInt(event.target.value, 10);

		const {
			filterModel,
			filterText,
			hasSearched,
			columnVisibility,
			lastFilterText,
			companyList,
			selectedCompanies,
		} = this.state;

		//  1) Get what is already stored in localStorage
		const stored = getFilter(['Reports', 'VendorInvoicesReport']) || {};
		const storedSelectedCompanyCodes = Array.isArray(stored.selectedCompanies)
			? stored.selectedCompanies
			: [];

		// 2) Fallback to state if nothing in storage
		const stateSelectedCompanyCodes = (selectedCompanies || []).map(c => c.companyCode);

		const selectedCompanyCodes =
			storedSelectedCompanyCodes.length > 0
				? storedSelectedCompanyCodes
				: stateSelectedCompanyCodes;

		// 3) Rebuild selectedCompanies in state from codes
		const nextSelectedCompanies = companyList.filter(c =>
			selectedCompanyCodes.indexOf(c.companyCode) > -1
		);

		this.setState({
			data: [],
			modelDefId,
			filterModel,
			filterText,
			lastFilterText,
			companyList,
			selectedCompanies: nextSelectedCompanies,
			hasSearched,
		}, () => {

			this.mainGridRef.current?.setFilterModel({
				...filterModel,
				quickFilterValues: [filterText || ''],
			});

			setFilter(['Reports', 'VendorInvoicesReport'], {
				...stored,
				modelDefId,
				filterModel,
				filterText,
				columnVisibility,
				hasSearched,

			});

			this.fetchVendorInvoices({
				modelDefId,
				filterModel,
				companiesList: selectedCompanyCodes,
				searchText: hasSearched ? filterText : '',
			});
		});
	}

	getFilteredRows() {
		const quickFilterText = this.state.filterText?.trim().toLowerCase() || '';
		if (!quickFilterText) return this.state.data;
		const dateFormatter = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC' });
		const formatDate = (value) => value ? dateFormatter.format(new Date(value)) : '';

		return this.state.data.filter(row => (`${Object.values(row).join(' ')} ${this.resolveInvoiceStatusText(row, this.state.statusList || {})} ${Number(row?.invoiceSource) === 1 ? 'EDI' : 'PDF'} ${row?.isArchive === 'Y' ? 'Yes' : 'No'} ${formatDate(row?.invoiceDate)} ${formatDate(row?.dueDate)} ${formatDate(row?.serviceTermStartDate)} ${formatDate(row?.serviceTermEndDate)} ${formatDate(row?.uploadDate)} ${formatDate(row?.modifyDate)} ${formatDate(row?.invoiceDocumentPostingUpdateDate)} ${formatNumber(row?.quantity)} ${formatNumber(row?.ioInvoiceAmount)} ${formatNumber(row?.discountAmount)} ${formatNumber(row?.netCost)} ${formatNumber(row?.matchToDateNet)} ${formatNumber(row?.remainingAmount)} ${formatNumber(row?.totalInvoiceAmount)} ${formatNumber(row?.poAmount)} ${formatNumber(row?.consumedAmount)} ${formatNumber(row?.deliveryAmount)} ${formatNumber(row?.taxAmount)} ${formatNumber(row?.vendorTaxAmounts)} ${formatNumber(row?.taxAmountDiff)}`).toLowerCase().includes(quickFilterText));
	}

	searchCallback = (searchText) => {
		const trimmedText = (searchText || "").toLowerCase();

		if (trimmedText === "") {
			this.setState({ filteredData: [...this.state.data] });
			return;
		}

		const filtered = this.state.data.filter(row =>
			Object.values(row).some(val =>
				(val + '').toLowerCase().includes(trimmedText)
			)
		);

		this.setState({ filteredData: filtered });
	}
	fetchCompanyList = () => {
		const uri = `/api/invoicedocument/companyList?resourceId=${encodeURIComponent(this.resourceId)}`;

		httpGet(uri)
			.then((response) => {
				const companyData = response.data;

				const initialCompany = companyData.find(
					(company) => company.companyCode === this.companyCode
				);
				this.setState({ ...this.state, companyList: companyData, selectedCompanies: [initialCompany] })
			})
			.catch((error) => {
				toast.error('Error fetching company list');
			});
	};

	normalizeFilterModel(model) {
		return {
			items: [...(model?.items || [])],
			logicOperator: model?.logicOperator || 'and'
		};
	}

	handleFilterPanelSearch = (incomingFilterModel, quickFilterText = '') => {

		const normalizedModel = this.normalizeFilterModel(incomingFilterModel);
		//const isServerMode = !this.fieldInModel(normalizedModel, 'uploadDate');

		const updatedModel = {
			...normalizedModel,
			items: normalizedModel.items.map(f => ({
				...f,
				field: f.field === 'invoiceSource' ? 'fileSource' : f.field
			}))
		};

		this.setState({
			filterModel: updatedModel,
			filterText: quickFilterText,
			hasSearched: true
			//isServerMode
		}, () => {
			// ✅ Now it will fetch data
			var selectedCompanies = this.state.selectedCompanies.map(e => e.companyCode);
			setFilter(['Reports', 'VendorInvoicesReport'], {
				filterModel: updatedModel,
				filterText: quickFilterText,
				modelDefId: this.state.modelDefId,
				selectedCompanies: selectedCompanies,
				columnVisibility: this.state.columnVisibility,
				hasSearched: true,
			});
			this.fetchVendorInvoices({
				modelDefId: this.state.modelDefId,
				filterModel: updatedModel,
				companiesList: selectedCompanies,
				searchText: quickFilterText
			});
		});
	};


	fetchVendorInvoices({
		modelDefId,
		filterModel,
		searchText,
		companiesList = [],
		exportData = false
	}) {
		this.props.inProgress(true);

		const _uFilterModel = this.getFilterItems(filterModel);

		httpPost('/api/reports/vendorinvoices', {
			searchFilter: searchText,
			otherFilters: JSON.stringify(
				(_uFilterModel.items || [])
					.map((f, idx) => ({
						id: idx,
						field: splitByUppercase(f.field).join('_'),
						operator: f.operator,
						value:
							f.operator === 'isEmpty' || f.operator === 'isNotEmpty'
								? true
								: f.value
					}))
					.filter(f => f.value !== undefined && f.value !== '')
			),
			companies: companiesList.join(','),
			logicOperator: _uFilterModel.logicOperator,
			ModelDefId: modelDefId,
			isAll: !!exportData
		})
			.then((response) => {
				const { rows = [], statusList = {} } = response.data || {};

				const rowsWithIds = this.assignRowIds(rows);

				if (exportData) {
					this.setState({
						exportData: rowsWithIds,
						dataLoaded: true,
						tempTableEnabled: true,
						statusList
					});
				} else {
					this.setState({
						data: rowsWithIds,
						filteredData: rowsWithIds,
						statusList,
						taxSetting: null
					});
				}

				this.props.inProgress(false);
			})
			.catch((error) => {
				this.props.inProgress(false);

				if (exportData) {
					this.setState({ tempTableEnabled: false });
				}

				toast.error('An error occurred while fetching the records');
				console.error('There was an error!', error);
			});
	}
	getInvoiceTypeMenuItem(modelDefId, displayValue) {
		if (this.state.userInfo.invoiceType.includes('' + modelDefId)) {
			return <MenuItem value={modelDefId}>{displayValue}</MenuItem>
		}
	}
	getFilterItems(filterModel) {
		//let _filterModel = filterModel;

		//if (!_filterModel) {
		//	return {
		//		items: [],
		//		logicOperator: 'and'
		//	};
		//}

		//if (!_filterModel.items && _filterModel.field) {
		//	_filterModel = {
		//		items: [_filterModel],
		//		logicOperator: 'and'
		//	};
		//}

		//if (this.state.isServerMode) {
		//	_filterModel.items = (_filterModel.items || []).filter(f => f.field !== 'uploadDate');
		//}

		//return _filterModel;
		return filterModel;
	}


	fieldInModel(model, fieldName) {
		const relevantOperators = ['after', 'onOrAfter', 'before', 'onOrBefore'];

		if (!model) return false;

		// Case 1: standard MUI filterModel
		if (Array.isArray(model.items)) {
			return model.items.some(f =>
				f.field === fieldName && (!f.operator || relevantOperators.includes(f.operator))
			);
		}

		// Case 2: single filter object (failsafe)
		if (model.field === fieldName) {
			return !model.operator || relevantOperators.includes(model.operator);
		}

		return false;
	}

	detail_clickHandler(row) {
		this.setState({
			openInvoiceDocumentEditorDialog: true,
			mode: Constants?.VIEW || 'View',
			rowData: row,
			activeRowKey: row?.rowId ?? null,
			activeInvoiceDocumentId: row?.invoiceDocumentId ?? null
		});
	}

	delay(ms) {
		return new Promise((resolve) => setTimeout(resolve, ms));
	}

	addLoadingRows(rowIds = []) {
		if (!rowIds || rowIds.length === 0) return;
		this.setState(prev => {
			const prevIds = prev.loadingRowIds || [];
			const merged = Array.from(new Set([...prevIds, ...rowIds]));
			return { ...prev, loadingRowIds: merged };
		});
	}

	removeLoadingRows(rowIds = []) {
		if (!rowIds || rowIds.length === 0) return;
		this.setState(prev => {
			const prevIds = prev.loadingRowIds || [];
			return { ...prev, loadingRowIds: prevIds.filter(id => !rowIds.includes(id)) };
		});
	}

	isRowLoading(invoiceDocumentId) {
		return (this.state.loadingRowIds || []).includes(invoiceDocumentId);
	}

	// A row is considered "Post In Progress" if either the resolved status text or the post-status says so.
	isPostInProgressRow(row) {
		const postStatus = (row?.invoicePostStatus || '').toString().toLowerCase();
		const resolved = this.resolveInvoiceStatusText(row, this.state.statusList || {})
			.toString()
			.toLowerCase();
		return postStatus === 'post in progress' || resolved === 'post in progress';
	}


	removeRowFromGrid(invoiceDocumentId) {
		this.setState((prev) => {
			const activeRow = (prev.data || []).find((r) => r.rowId === prev.activeRowKey);
			const shouldClearActive = !!activeRow && activeRow.invoiceDocumentId === invoiceDocumentId;

			return {
				...prev,
				data: (prev.data || []).filter((r) => r.invoiceDocumentId !== invoiceDocumentId),
				filteredData: (prev.filteredData || []).filter((r) => r.invoiceDocumentId !== invoiceDocumentId),
				loadingRowIds: (prev.loadingRowIds || []).filter((id) => id !== invoiceDocumentId),
				activeRowKey: shouldClearActive ? null : prev.activeRowKey,
				activeInvoiceDocumentId: shouldClearActive ? null : prev.activeInvoiceDocumentId
			};
		});
	}

	async fetchReportRowByInvoiceId(invoiceDocumentId, companyCode) {
		if (!invoiceDocumentId) return null;
		try {
			// ✅ Row refetch now uses a dedicated packet param (invoiceDocumentId),
			// instead of sending it as a search/otherFilters clause.
			const response = await httpPost('/api/reports/vendorinvoices', {
				searchFilter: '',
				otherFilters: JSON.stringify([]),
				companies: (companyCode ? String(companyCode) : (this.state.selectedCompanies || []).map(e => e.companyCode).join(',')),
				logicOperator: 'and',
				ModelDefId: this.state.modelDefId,
				invoiceDocumentId: invoiceDocumentId, // ✅ NEW param (maps to invoice_document_id_param in SP)
				isAll: false
			});
			const rows = response?.data?.rows || [];


			return rows.length > 0 ? rows : null;
		} catch (e) {
			return null;
		}
	}

	async refreshRowViaReportApi(invoiceDocumentId, companyCode, options = {}, isCreditMemo = false, applyToInvoiceDocumentId = null) {
		const manageLoading = options?.manageLoading !== false;
		if (manageLoading) {
			this.addLoadingRows([invoiceDocumentId]);
		}

		const oldRows = (this.state.data || []).find(r => r.invoiceDocumentId === invoiceDocumentId);

		const updatedRows = await this.fetchReportRowByInvoiceId(
			invoiceDocumentId,
			companyCode
		);

		if (!updatedRows || updatedRows.length === 0) {
			if (manageLoading) {
				this.removeLoadingRows([invoiceDocumentId]);
			}

			// fallback: reload full report
			this.fetchVendorInvoices({
				modelDefId: this.state.modelDefId,
				filterModel: this.state.filterModel,
				searchText: this.state.filterText,
				companiesList: (this.state.selectedCompanies || []).map(e => e.companyCode)
			});

			return;
		}

		const newRowsWithIds = this.assignRowIds(updatedRows);

		this.setState(prev => {
			// ---- DATA ----
			const firstIndex = prev.data.findIndex(
				r => r.invoiceDocumentId === invoiceDocumentId
			);

			const dataWithoutInvoice = prev.data.filter(
				r => r.invoiceDocumentId !== invoiceDocumentId
			);

			const insertIndex =
				firstIndex === -1 ? dataWithoutInvoice.length : firstIndex;

			const newData = [
				...dataWithoutInvoice.slice(0, insertIndex),
				...newRowsWithIds,
				...dataWithoutInvoice.slice(insertIndex)
			];

			// ---- FILTERED DATA ----
			const filteredFirstIndex = prev.filteredData.findIndex(
				r => r.invoiceDocumentId === invoiceDocumentId
			);

			const filteredWithoutInvoice = prev.filteredData.filter(
				r => r.invoiceDocumentId !== invoiceDocumentId
			);

			const filteredInsertIndex =
				filteredFirstIndex === -1
					? filteredWithoutInvoice.length
					: filteredFirstIndex;

			const newFilteredData = [
				...filteredWithoutInvoice.slice(0, filteredInsertIndex),
				...newRowsWithIds,
				...filteredWithoutInvoice.slice(filteredInsertIndex)
			];

			return {
				data: newData,
				filteredData: newFilteredData,
				loadingRowIds: manageLoading
					? (prev.loadingRowIds || []).filter(id => id !== invoiceDocumentId)
					: (prev.loadingRowIds || [])
			};
		}, () => {
			if (isCreditMemo) {
				let updateRow = (this.state.data || []).find(r => r.invoiceDocumentId === invoiceDocumentId);

				if (updateRow && applyToInvoiceDocumentId
					&& Number(applyToInvoiceDocumentId) > 0
					&& updateRow.invoiceDocumentStatusId === 170 &&
					oldRows.invoiceDocumentStatusId !== 180
				) {
					this.setState({
						openCreditMemoRepostDialog: true,
						creditMemoRowForRepost: updateRow,
						applyToInvoiceDocumentId: applyToInvoiceDocumentId
					});
				}
			}

		});
	}

	// ✅ Credit memo flow helper:
	// Fetch newly created invoice rows (e.g., credit memo) from report API and insert them
	// immediately after an anchor invoice (the source invoice) so the user can see the memo
	// next to the invoice it was created from.
	async insertInvoiceRowsAfterAnchor(newInvoiceDocumentId, anchorInvoiceDocumentId, companyCode, attempts = 3, delayMs = 2000, entityLabel = 'Invoice') {
		if (!newInvoiceDocumentId) return false;

		// Give backend a moment to create rows
		await this.delay(delayMs);

		let rows = null;
		for (let i = 0; i < attempts; i++) {
			rows = await this.fetchReportRowByInvoiceId(newInvoiceDocumentId, companyCode);
			if (rows && rows.length > 0) break;
			if (i < attempts - 1) {
				await this.delay(delayMs);
			}
		}

		if (!rows || rows.length === 0) {
			toast.warning(`${entityLabel} created, but it is not available in the report yet.`);
			return false;
		}

		const newRowsWithIds = this.assignRowIds(rows);

		this.setState((prev) => {
			const data = prev.data || [];
			const filteredData = prev.filteredData || [];

			// Remove existing rows for the new invoice if any (idempotent)
			const dataWithoutNew = data.filter(r => r.invoiceDocumentId !== newInvoiceDocumentId);
			const filteredWithoutNew = filteredData.filter(r => r.invoiceDocumentId !== newInvoiceDocumentId);

			// Insert AFTER the last row of the anchor invoice (if found), else append to end
			let insertIndex = dataWithoutNew.length;
			if (anchorInvoiceDocumentId) {
				let lastAnchorIdx = -1;
				for (let i = 0; i < dataWithoutNew.length; i++) {
					if (dataWithoutNew[i]?.invoiceDocumentId === anchorInvoiceDocumentId) {
						lastAnchorIdx = i;
					}
				}
				insertIndex = lastAnchorIdx >= 0 ? lastAnchorIdx + 1 : dataWithoutNew.length;
			}

			const newData = [
				...dataWithoutNew.slice(0, insertIndex),
				...newRowsWithIds,
				...dataWithoutNew.slice(insertIndex)
			];

			// Insert into filteredData only if anchor invoice is visible there
			let newFilteredData = filteredWithoutNew;
			if (anchorInvoiceDocumentId) {
				let lastFilteredAnchorIdx = -1;
				for (let i = 0; i < filteredWithoutNew.length; i++) {
					if (filteredWithoutNew[i]?.invoiceDocumentId === anchorInvoiceDocumentId) {
						lastFilteredAnchorIdx = i;
					}
				}
				if (lastFilteredAnchorIdx >= 0) {
					newFilteredData = [
						...filteredWithoutNew.slice(0, lastFilteredAnchorIdx + 1),
						...newRowsWithIds,
						...filteredWithoutNew.slice(lastFilteredAnchorIdx + 1)
					];
				}
			}

			return {
				...prev,
				data: newData,
				filteredData: newFilteredData
			};
		});

		return true;
	}



	async replaceInvoiceRowByFileKey(oldInvoiceDocumentId, fileKey, companyCode, attempts = 3, delayMs = 2000) {
		if (!oldInvoiceDocumentId || !fileKey) return;

		this.addLoadingRows([oldInvoiceDocumentId]);

		try {
			// ✅ Wait before first lookup (gives backend time to create the new invoice)
			await this.delay(delayMs);

			let newInvoiceDocumentId = null;

			for (let i = 0; i < attempts; i++) {
				try {
					// 1) Find the new invoice created by replace (by fileKey)
					if (!newInvoiceDocumentId) {
						const uri =
							'/api/invoicedocument/invoicedocumenteditorbyfilename?invoiceDocumentFileLocation=' +
							encodeURIComponent(fileKey) +
							(companyCode ? ('&companyCode=' + encodeURIComponent(companyCode)) : '');

						const res = await httpGet(uri);
						newInvoiceDocumentId = res?.data?.invoiceDocumentId || null;
					}

					// 2) Once we have the new invoice id, try to fetch the report row(s)
					if (newInvoiceDocumentId) {
						const updatedRows = await this.fetchReportRowByInvoiceId(newInvoiceDocumentId, companyCode);

						if (updatedRows && updatedRows.length > 0) {
							const newRowsWithIds = this.assignRowIds(updatedRows);

							this.setState((prev) => {
								// Remove ALL rows for old invoice
								const firstDataIndex = (prev.data || []).findIndex(r => r.invoiceDocumentId === oldInvoiceDocumentId);
								const dataWithoutOld = (prev.data || []).filter(r => r.invoiceDocumentId !== oldInvoiceDocumentId);

								const insertDataIndex = firstDataIndex >= 0 ? firstDataIndex : dataWithoutOld.length;
								const newData = [
									...dataWithoutOld.slice(0, insertDataIndex),
									...newRowsWithIds,
									...dataWithoutOld.slice(insertDataIndex)
								];

								// Keep filteredData consistent: only insert if the old invoice was visible there
								const firstFilteredIndex = (prev.filteredData || []).findIndex(r => r.invoiceDocumentId === oldInvoiceDocumentId);
								const filteredWithoutOld = (prev.filteredData || []).filter(r => r.invoiceDocumentId !== oldInvoiceDocumentId);

								let newFilteredData = filteredWithoutOld;
								if (firstFilteredIndex >= 0) {
									newFilteredData = [
										...filteredWithoutOld.slice(0, firstFilteredIndex),
										...newRowsWithIds,
										...filteredWithoutOld.slice(firstFilteredIndex)
									];
								}

								// Clear active row selection if it belonged to old invoice
								const activeRow = (prev.data || []).find((r) => r.rowId === prev.activeRowKey);
								const shouldClearActive = !!activeRow && activeRow.invoiceDocumentId === oldInvoiceDocumentId;

								return {
									...prev,
									data: newData,
									filteredData: newFilteredData,
									activeRowKey: shouldClearActive ? null : prev.activeRowKey,
									activeInvoiceDocumentId: shouldClearActive ? null : prev.activeInvoiceDocumentId,
									loadingRowIds: (prev.loadingRowIds || []).filter(id => id !== oldInvoiceDocumentId)
								};
							});

							return; // ✅ done
						}
						// If report row isn't available yet, keep retrying
					}
				} catch (e) {
					// swallow and retry
				}

				if (i < attempts - 1) {
					await this.delay(delayMs);
				}
			}

			// Not found after retries -> remove old rows and inform user
			this.removeRowFromGrid(oldInvoiceDocumentId);
			toast.warning('Replace is still in progress. Removed the old row; the new invoice will appear once available.');
		} finally {
			// Ensure loading is cleared even if something threw
			this.removeLoadingRows([oldInvoiceDocumentId]);
		}
	}

	invoiceDocumentEditor_closeHandler({
		wasUpdate = false,
		updatedRowFieldsData = null,
		responseObject = null,
		invoiceDocumentId = null,
		wasDelete = false,
		isCompanyChanged = false,
		isAvailableForRescaning = false,
		applyToInvoiceDocumentId = null
	} = {}) {
		const oldRow = this.state.rowData;
		const companyCode = oldRow?.companyCode;
		const id = invoiceDocumentId || responseObject?.invoiceDocumentId || oldRow?.invoiceDocumentId;

		// IMPORTANT: do NOT clear activeRowKey here.
		// The row should remain highlighted until another row is opened.
		this.setState({ openInvoiceDocumentEditorDialog: false, rowData: null }, () => {
			// Company changed => close and remove row (invoice moved to another company)
			if (isCompanyChanged && id) {
				this.removeRowFromGrid(id);
				return;
			}

			// Delete => remove row
			if (wasDelete && id) {
				this.removeRowFromGrid(id);
				return;
			}

			// ✅ Credit memo created from a posted invoice:
			// Update the source invoice row AND fetch+insert the new credit memo row.
			// If credit memo was posted, show rescan dialog.
			if (responseObject?.operation === 'creditMemo' && invoiceDocumentId) {
				const sourceInvoiceDocumentId = oldRow?.invoiceDocumentId || null;
				const memoInvoiceDocumentId = invoiceDocumentId;
				if (sourceInvoiceDocumentId) {
					this.addLoadingRows([sourceInvoiceDocumentId]);
				}

				(async () => {
					try {
						if (sourceInvoiceDocumentId) {
							// Keep source row in loading state for the full chain
							await this.refreshRowViaReportApi(sourceInvoiceDocumentId, companyCode, { manageLoading: false });
						}
						await this.insertInvoiceRowsAfterAnchor(
							memoInvoiceDocumentId,
							sourceInvoiceDocumentId,
							companyCode,
							3,
							2000,
							'Credit memo'
						);
					} finally {
						if (sourceInvoiceDocumentId) {
							this.removeLoadingRows([sourceInvoiceDocumentId]);
						}
					}
				})();

				if (isAvailableForRescaning) {
					this.setState({
						openCreditMemoRepostDialog: true,
						creditMemoRowForRepost: updateRow,
						applyToInvoiceDocumentId: applyToInvoiceDocumentId
					});
				}

				return;
			}
			if (
				responseObject?.openLinkedInvoice === true &&
				responseObject?.invoiceDocumentId
			) {
				const isCreditMemo = responseObject.invoiceIndicator === 2;

				this.setState({
					openInvoiceDocumentEditorDialog: true,
					mode: isCreditMemo ? Constants.CREDIT_MEMO : Constants.VIEW,
					rowData: {
						invoiceDocumentId: responseObject.invoiceDocumentId
					},
					activeRowKey: null,
					activeInvoiceDocumentId: responseObject.invoiceDocumentId
				});

				return;
			}

			// Replace => try to find new invoice by filename, replace row or remove
			if (responseObject?.operation === 'replace' && id) {
				const fileKey = responseObject.invoiceDocumentFileLocation || responseObject.fileName;
				if (fileKey) {
					this.replaceInvoiceRowByFileKey(id, fileKey, companyCode);
					return;
				}
			}

			// Normal update => refresh row (report shape) like InvoiceDocument.js
			// Also refresh when we get updatedRowFieldsData (some paths might not toggle wasUpdate consistently).
			if ((wasUpdate || !!updatedRowFieldsData) && id) {
				if (isAvailableForRescaning) {
					this.props.inProgress(true);
				}
				this.refreshRowViaReportApi(id, companyCode, {}, isAvailableForRescaning, applyToInvoiceDocumentId)
					.finally(() => {
						this.props.inProgress(false);
					});
			}
		});
	}

	render() {
			const lookupFilter = Object.entries(this.state.statusList || {}).map(element => {
				let [key, value] = element;
				return value;
			});
			const cellStyle = { paddingLeft: 8, paddingRight: 45 };
			const filterCellStyle = { textAlign: 'right', paddingRight: 45 };
			const headerStyle = { textAlign: 'right' };
			const defaultCopyableStyle = {
				overflow: 'hidden',
				textOverflow: 'ellipsis',
				whiteSpace: 'nowrap',
				display: 'block',
				//width: '100%'
			};
			const wrappedCopyableStyle = {
				display: 'block',
				whiteSpace: 'normal',
				wordBreak: 'break-all',
				overflowWrap: 'break-word',
				//width: '100%',
				lineHeight: 1.4
			};
			const rightAlignedCopyableStyle = {
				...defaultCopyableStyle,
				textAlign: 'right'
			};
			const formatUtcDate = (value) => {
				if (!value) return '';
				const d = new Date(value);
				return new Intl.DateTimeFormat('en-US', { timeZone: 'UTC' }).format(d);
			};
			const renderCopyableCell = (displayValue, options = {}) => {
				const {
					copyValue = displayValue,
					tooltipTitle = displayValue,
					style = defaultCopyableStyle,
					tooltipPlacement = 'top-start'
				} = options;

				return (
					<CopyableCell
						value={copyValue ?? ''}
						tooltipTitle={tooltipTitle ?? ''}
						tooltipPlacement={tooltipPlacement}
						style={style}
					>
						{displayValue ?? ''}
					</CopyableCell>
				);
			};
			const rightAlignedHeader = (params) => (
				<div
					style={{
						width: '100%',
						textAlign: 'right',
						color: 'inherit',
						fontSize: '0.75rem',
						fontWeight: 500,
						lineHeight: '1.4em',
						whiteSpace: 'normal',
						wordBreak: 'break-word',
						overflow: 'hidden',
						textOverflow: 'ellipsis',
						display: '-webkit-box',
						WebkitLineClamp: 2,
						WebkitBoxOrient: 'vertical'
					}}
					title={params.colDef.headerName}
				>
					{params.colDef.headerName}
				</div>
			);
			const columns = [
				{
					headerName: 'Company',
					field: 'companyName',
					//valueGetter: (rowData) => {
					//	return rowData.companyCode
					//},
					//renderCell: (rowData) => {
					//	return '';
					//},
					filterable: false,
					renderCell: (params) => renderCopyableCell(params.value)
				},
				{
					headerName: 'Vendor Code',
					field: 'vendorCode',
					width: 100, hideable: false,
					renderCell: (params) => renderCopyableCell(params.value)
				},
				{
					headerName: 'Vendor Name',
					field: 'vendorName',
					width: 120, hideable: false,
					renderCell: (params) => renderCopyableCell(params.value)
				}
				//,
				//{
				//	headerName: 'Site Id',
				//	field: 'siteId',
				//	width: 250
				//},
			];
			if (this.state.modelDefId === 3) {
				columns.push(
					{
						headerName: 'Source',
						field: 'invoiceSource',
						valueGetter: ({ value }) => value == "1" ? "EDI" : "PDF",
						width: 100,
						renderCell: (params) => renderCopyableCell(params.value)
					});
			}
			columns.push({
				headerName: 'File Name',
				field: 'invoiceDocumentFileLocation',
				width: 200,
				minWidth: 200,
				renderCell: (rowData) => {
					const {
						invoiceSource,
						invoiceDocumentId,
						invoiceDocumentFileLocation,
						companyCode,
						ediFilename,
						rowId
					} = rowData.row;

					const isDownloading = this.state.downloadingInvoices[rowId];

					if (isDownloading) {
						return (
							<div
								style={{
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center',
									width: '100%',
									height: '100%',
								}}
							>
								<CircularProgress size={18} />
							</div>
						);
					}

					if (invoiceSource && invoiceSource == 1) {
						return (
							<div
								style={{
									display: 'flex',
									alignItems: 'center',
									gap: 8,
									width: '100%',
									overflow: 'hidden',
								}}
							>
								<span
									role="button"
									tabIndex={0}
									style={{
										display: 'flex',
										alignItems: 'center',
										cursor: 'pointer',
										flexShrink: 0,
									}}
									onClick={(e) => {
										e.preventDefault();
										e.stopPropagation();
										this.handleDownloadFile(
											this.state.modelDefId,
											rowId,
											invoiceDocumentFileLocation,
											companyCode
										);
									}}
								>
									<Tooltip title="View">
										{getFileIcon(invoiceDocumentFileLocation)}
									</Tooltip>
								</span>
								{renderCopyableCell(ediFilename, {
									style: {
										overflow: 'hidden',
										textOverflow: 'ellipsis',
										whiteSpace: 'nowrap',
										display: 'block',
									}
								})}
							</div>
						);
					}

					else if (invoiceDocumentFileLocation) {
						const displayName = invoiceDocumentFileLocation
							.split('_')
							.slice(1)
							.join('_');

						return (
							<div
								style={{
									display: 'flex',
									alignItems: 'center',
									gap: 8,
									width: '100%',
									overflow: 'hidden',
								}}
							>
								<span
									role="button"
									tabIndex={0}
									style={{
										display: 'flex',
										alignItems: 'center',
										cursor: 'pointer',
										flexShrink: 0,
									}}
									onClick={(e) => {
										e.preventDefault();
										e.stopPropagation();
										this.handleDownloadFile(
											this.state.modelDefId,
											rowId,
											invoiceDocumentFileLocation,
											companyCode
										);
									}}
								>
									<Tooltip title="View">
										{getFileIcon(invoiceDocumentFileLocation)}
									</Tooltip>
								</span>

								{renderCopyableCell(displayName, {
									style: {
										overflow: 'hidden',
										textOverflow: 'ellipsis',
										whiteSpace: 'nowrap',
										maxWidth: '100%',
										display: 'block',
									}
								})}
							</div>
						);
					}

					return renderCopyableCell(rowData.row.invoiceDocumentFileLocation);
				}

			},
				{
					headerName: 'Invoice Number',
					field: 'invoiceNumber',
					width: 100,
					renderCell: (params) => renderCopyableCell(params.value, { style: wrappedCopyableStyle })
				},

				{
					headerName: getDisplayName('User Status'),
					field: 'invoiceUserStatus',
					width: 120,
					renderCell: (params) => renderCopyableCell(params.value)
				});
			if (this.state.modelDefId === 2) {
				columns.push(
					{
						headerName: 'PO Code',
						field: 'poCode',
						width: 100,
						renderCell: (params) => renderCopyableCell(params.value)
					});
			}
			if (this.state.modelDefId === 3) {
				columns.push(
					{
						headerName: 'Advertiser/Product',
						field: 'advertiserProduct',
						width: 150,
						renderCell: (params) => renderCopyableCell(params.value)
					});
				//Contract Number
				columns.push(
					{
						headerName: 'Contract Number',
						field: 'contractNumber',
						width: 150,
						renderCell: (params) => renderCopyableCell(params.value)
					});
			}
			columns.push({
				headerName: 'Status',
				type: 'singleSelect',
				field: 'invoiceDocumentStatus',
				width: 140,
				minWidth: 140,
				filterCellStyle: { width: 40, maxWidth: 40 },

				valueOptions: () =>
					Object.entries(this.state.statusList).map(([key, label]) => ({
						value: label,
						label
					})),
				valueGetter: (params) => {
					const statusText = this.resolveInvoiceStatusText(
						params.row,
						this.state.statusList
					);
					return statusText;
				},


				// Spinner + Reload moved into Status column
				renderCell: (params) => {
					const row = params.row;
					const invoiceId = row?.invoiceDocumentId;
					const statusText = this.resolveInvoiceStatusText(row, this.state.statusList);
					const isPostInProgress = this.isPostInProgressRow(row);
					const isLoading = !!invoiceId && this.isRowLoading(invoiceId);
					const postedUserName = row?.postedUserName;

					const hasTrailingAction = isLoading || isPostInProgress;

					return (
						<div
							style={{
								display: 'flex',
								alignItems: 'center',
								width: '100%',
								gap: hasTrailingAction ? 6 : 0, // 👈 no dead space
							}}
						>
							<CopyableCell
								value={statusText || ''}
								tooltipTitle={postedUserName ? `${statusText} by: ${postedUserName}` : statusText || ''}
								style={{
									flex: 1,
									overflow: 'hidden',
									textOverflow: 'ellipsis',
									whiteSpace: 'nowrap',
									cursor: 'default',
									display: 'block'
								}}
							>
								{statusText}
							</CopyableCell>

							{/* Spinner — only when loading */}
							{isLoading && (
								<CircularProgress
									size={18}
									onClick={(e) => e.stopPropagation()}
								/>
							)}

							{/* Reload — only when Post In Progress and not loading */}
							{isPostInProgress && !isLoading && (
								<Tooltip title="Reload">
									<IconButton
										size="small"
										onClick={(e) => {
											e.preventDefault();
											e.stopPropagation();
											this.refreshRowViaReportApi(invoiceId, row?.companyCode);
										}}
										aria-label="Reload"
									>
										<ReplayIcon fontSize="small" />
									</IconButton>
								</Tooltip>
							)}
						</div>
					);
				}

			},
				{
					headerName: 'Assigned To',
					field: 'assignedTo',
					filterCellStyle: { width: 40, maxWidth: 40 },
					renderCell: rowData => {
						if (rowData.row.assignedTo && rowData.row.assignedTo.split('|').length > 1)
							return <div>
								<CopyableCell
									value={rowData.row.assignedTo}
									tooltipTitle={
										<span style={{ whiteSpace: 'pre-line' }}>{rowData.row.assignedTo.split('|').join("\n")}</span>
									}
									style={{ display: 'inline-block', maxWidth: '100%' }}
								>
									<Link>{rowData.row.assignedTo.split('|')[0]} ...</Link>
								</CopyableCell>
							</div>;
						return renderCopyableCell(rowData.row.assignedTo);
					},
					width: 130
				},
				{
					field: 'invoiceDate',
					headerName: 'Invoice Date',
					width: 100,
					valueGetter: ({ value }) => value || '',
					valueFormatter: ({ value }) => {
						if (!value) return '';
						const d = new Date(value);
						return new Intl.DateTimeFormat('en-US', { timeZone: 'UTC' }).format(d);
					},
					type: 'date',
					renderCell: (params) => renderCopyableCell(params.formattedValue || formatUtcDate(params.value))
				},

				{
					headerName: 'Due Date',
					field: 'dueDate',
					width: 100,
					valueGetter: ({ value }) => value || '',
					valueFormatter: ({ value }) => {
						if (!value) return '';
						const d = new Date(value);
						return new Intl.DateTimeFormat('en-US', { timeZone: 'UTC' }).format(d);
					},
					type: 'date',
					renderCell: (params) => renderCopyableCell(params.formattedValue || formatUtcDate(params.value))
				},


				{
					headerName: 'Payment Term',
					field: 'paymentTermCode',
					width: 100,
					renderCell: (params) => renderCopyableCell(params.value)
				});
			if (this.state.modelDefId !== 2) {
				columns.push(
					{
						headerName: 'Service Term From',
						field: 'serviceTermStartDate',
						width: 100,
						valueGetter: ({ value }) => value || '',
						valueFormatter: ({ value }) => {
							if (!value) return '';
							const d = new Date(value);
							return new Intl.DateTimeFormat('en-US', { timeZone: 'UTC' }).format(d);
						},
						type: 'date',
						renderCell: (params) => renderCopyableCell(params.formattedValue || formatUtcDate(params.value))
					},
					{
						headerName: 'Service Term To',
						field: 'serviceTermEndDate',
						width: 100,
						valueGetter: ({ value }) => value || '',
						valueFormatter: ({ value }) => {
							if (!value) return '';
							const d = new Date(value);
							return new Intl.DateTimeFormat('en-US', { timeZone: 'UTC' }).format(d);
						},
						type: 'date',
						renderCell: (params) => renderCopyableCell(params.formattedValue || formatUtcDate(params.value))
					},
				);
			}
			if (this.state.modelDefId === 2) {
				columns.push({
					headerName: 'Customer Code',
					field: 'clientCode',
					width: 100,
					renderCell: (params) => renderCopyableCell(params.value)
				},
					{
						headerName: 'Customer Name',
						field: 'clientName',
						width: 120,
						renderCell: (params) => renderCopyableCell(params.value)
					});
			}
			columns.push(
				{
					headerName: 'Currency',
					field: 'currencyCode',
					width: 80,
					renderCell: (params) => renderCopyableCell(params.value)
				});
			if (this.state.modelDefId !== 2) {
				columns.push(
					{
						headerName: 'Client Code',
						field: 'clientCode',
						width: 100,
						renderCell: (params) => renderCopyableCell(params.value)
					},
					{
						headerName: 'Client Name',
						field: 'clientName',
						width: 120,
						renderCell: (params) => renderCopyableCell(params.value)
					}
				);
				if (this.state.modelDefId === 1) {
					columns.push(
						{
							headerName: 'Project Code',
							field: 'level2',
							width: 150,
							renderCell: (params) => renderCopyableCell(params.value)
						}
					);
				}

				if (this.state.modelDefId !== 3) {
					columns.push(
						{
							headerName: 'Campaign Name',
							field: 'description',
							width: 150,
							renderCell: (params) => renderCopyableCell(params.value)
						},
					);
				}
				if (this.state.modelDefId === 1) {
					columns.push(
						{
							headerName: 'Media Plan Name',
							field: 'mediaPlanName',
							width: 150,
							renderCell: (params) => renderCopyableCell(params.value)
						}
					)
				}
				if (this.state.modelDefId !== 3) {
					columns.push(
						{
							headerName: 'IO/PO Number',
							field: 'ioNumber',
							width: 120,
							renderCell: (params) => renderCopyableCell(params.value)
						}
					)
				}

				// columns.push({
				//     headerName: 'IO/PO Description',
				//     field: 'ioDescription',
				//     width: 250
				// });
			}
			if (this.state.modelDefId === 2) {
				columns.push(
					{
						headerName: 'Project',
						field: 'level2Key',
						width: 120,
						renderCell: (params) => renderCopyableCell(params.value)
					},
					{
						headerName: 'Project Desc.',
						field: 'description',
						width: 150,
						renderCell: (params) => renderCopyableCell(params.value)
					},
					{
						headerName: 'Activity',
						field: 'level3Key',
						width: 100,
						renderCell: (params) => renderCopyableCell(params.value)
					},
					{
						headerName: 'Expense Type',
						field: 'rTypeName',
						width: 100,
						renderCell: (params) => renderCopyableCell(params.value)
					},
					{
						headerName: 'Quantity',
						field: 'quantity',
						type: 'number',
						valueGetter: ({ value }) => (value && Number(value)) || 0,
						width: 80,
						align: 'right',
						headerAlign: 'right',
						renderHeader: rightAlignedHeader,
						filterOperators: numberFilterOperators,
						renderCell: (params) => renderCopyableCell(formatNumber(params.value), { style: rightAlignedCopyableStyle })
					}
				);
			}

			columns.push(
				{
					headerName: this.state.modelDefId === 2 ? 'Amount' : 'Invoice Net Amount',
					field: 'ioInvoiceAmount',
					type: 'number',
					valueGetter: ({ value }) => Number(value),
					valueFormatter: ({ value }) => formatNumber(value),
					renderCell: (params) => renderCopyableCell(formatNumber(params.value), { style: rightAlignedCopyableStyle }),
					renderHeader: rightAlignedHeader,
					width: 100,
					align: 'right',
					cellStyle: cellStyle,
					filterCellStyle: filterCellStyle,
					headerStyle: headerStyle,
					headerAlign: 'right',
					filterOperators: numberFilterOperators,
				}
			);

			if (this.state.modelDefId !== 3) {
				columns.push(
					{
						headerName: 'Discount Amount',
						field: 'discountAmount',
						type: 'number',
						valueGetter: ({ value }) => Number(value),
						valueFormatter: ({ value }) => formatNumber(value),
						renderCell: (params) => renderCopyableCell(formatNumber(params.value), { style: rightAlignedCopyableStyle }),
						width: 100,
						cellStyle: cellStyle,
						filterCellStyle: filterCellStyle,
						headerStyle: headerStyle,
						align: 'right',
						headerAlign: 'right',
						renderHeader: rightAlignedHeader,
						filterOperators: numberFilterOperators,
					}
				);
			}
			if (this.state.modelDefId === 2) {
				columns.push(
					{
						headerName: 'Net Cost',
						field: 'netCost',
						type: 'number',
						valueGetter: ({ value }) => Number(value),
						valueFormatter: ({ value }) => formatNumber(value),
						renderCell: (params) => renderCopyableCell(formatNumber(params.value), { style: rightAlignedCopyableStyle }),
						width: 100,
						cellStyle: cellStyle,
						headerStyle: headerStyle,
						filterCellStyle: filterCellStyle,
						align: 'right',
						headerAlign: 'right',
						renderHeader: rightAlignedHeader,
						filterOperators: numberFilterOperators,
					},
					{
						headerName: 'Consumed Amount',
						field: 'matchToDateNet',
						type: 'number',
						cellStyle: cellStyle,
						headerStyle: headerStyle,
						filterCellStyle: filterCellStyle,
						valueGetter: ({ value }) => Number(value),
						valueFormatter: ({ value }) => formatNumber(value),
						renderCell: (params) => renderCopyableCell(formatNumber(params.value), { style: rightAlignedCopyableStyle }),
						width: 100,
						align: 'right',
						headerAlign: 'right',
						renderHeader: rightAlignedHeader,
						filterOperators: numberFilterOperators,
					},
					{
						headerName: 'Remaining Amount',
						field: 'remainingAmount',
						type: 'number',
						valueGetter: ({ value }) => Number(value),
						valueFormatter: ({ value }) => formatNumber(value),
						renderCell: (params) => renderCopyableCell(formatNumber(params.value), { style: rightAlignedCopyableStyle }),
						width: 100,
						align: 'right',
						cellStyle: cellStyle,
						headerStyle: headerStyle,
						filterCellStyle: filterCellStyle,
						headerAlign: 'right',
						renderHeader: rightAlignedHeader,
						filterOperators: numberFilterOperators,
					});
			}

			columns.push(
				{
					headerName: 'Total Invoice Amount',
					field: 'totalInvoiceAmount',
					type: 'number',
					cellStyle: cellStyle,
					filterCellStyle: filterCellStyle,
					headerStyle: headerStyle,
					valueGetter: ({ value }) => Number(value),
					valueFormatter: ({ value }) => formatNumber(value),
					renderCell: (params) => renderCopyableCell(formatNumber(params.value), { style: rightAlignedCopyableStyle }),
					width: 100,
					align: 'right',
					headerAlign: 'right',
					renderHeader: rightAlignedHeader,
					filterOperators: numberFilterOperators,
				}
			);
			if (this.state.modelDefId === 1) {
				columns.push(
					{
						headerName: 'IO/PO Amount',
						field: 'poAmount',
						type: 'number',
						cellStyle: cellStyle,
						headerStyle: headerStyle,
						filterCellStyle: filterCellStyle,
						valueGetter: ({ value }) => Number(value),
						valueFormatter: ({ value }) => formatNumber(value),
						renderCell: (params) => renderCopyableCell(formatNumber(params.value), { style: rightAlignedCopyableStyle }),
						width: 100,
						align: 'right',
						headerAlign: 'right',
						renderHeader: rightAlignedHeader,
						filterOperators: numberFilterOperators,
					},
					{
						headerName: 'Consumed Amount',
						field: 'consumedAmount',
						type: 'number',
						cellStyle: cellStyle,
						headerStyle: headerStyle,
						filterCellStyle: filterCellStyle,
						valueGetter: ({ value }) => Number(value),
						valueFormatter: ({ value }) => formatNumber(value),
						renderCell: (params) => renderCopyableCell(formatNumber(params.value), { style: rightAlignedCopyableStyle }),
						width: 100,
						align: 'right',
						headerAlign: 'right',
						renderHeader: rightAlignedHeader,
						filterOperators: numberFilterOperators,
					},
					{
						headerName: 'Delivery Amount',
						field: 'deliveryAmount',
						type: 'number',
						valueGetter: ({ value }) => Number(value),
						valueFormatter: ({ value }) => formatNumber(value),
						renderCell: (params) => renderCopyableCell(formatNumber(params.value), { style: rightAlignedCopyableStyle }),
						width: 100,
						cellStyle: cellStyle,
						headerStyle: headerStyle,
						filterCellStyle: filterCellStyle,
						align: 'right',
						headerAlign: 'right',
						renderHeader: rightAlignedHeader,
						filterOperators: numberFilterOperators,
					});
			}
			columns.push(
				{
					headerName: 'Tax Amount',
					field: 'taxAmount',
					type: 'number',
					cellStyle: cellStyle,
					headerStyle: headerStyle,
					filterCellStyle: filterCellStyle,
					valueGetter: ({ value }) => Number(value),
					valueFormatter: ({ value }) => formatNumber(value),
					renderCell: (params) => renderCopyableCell(formatNumber(params.value), { style: rightAlignedCopyableStyle }),
					width: 100,
					align: 'right',
					headerAlign: 'right',
					renderHeader: rightAlignedHeader,
					filterOperators: numberFilterOperators,
				});

			//if (this.state.taxSetting === 2) {
			columns.push({
				headerName: 'Tax Amt based on Vendor',
				field: 'vendorTaxAmounts',
				type: 'number',
				valueGetter: ({ value }) => Number(value),
				valueFormatter: ({ value }) => formatNumber(value),
				renderCell: (params) => renderCopyableCell(formatNumber(params.value), { style: rightAlignedCopyableStyle }),
				width: 100,
				align: 'right',
				headerAlign: 'right',
				renderHeader: rightAlignedHeader,
				filterOperators: numberFilterOperators,
			},
				{
					headerName: 'Tax Diff.',
					field: 'taxAmountDiff',
					type: 'number',
					valueGetter: ({ value }) => Number(value),
					valueFormatter: ({ value }) => formatNumber(value),
					renderCell: (params) => renderCopyableCell(formatNumber(params.value), { style: rightAlignedCopyableStyle }),
					width: 100,
					align: 'right',
					headerAlign: 'right',
					renderHeader: rightAlignedHeader,
					filterOperators: numberFilterOperators,
				});
			//}

			columns.push(
				{
					headerName: 'Transaction Id',
					field: 'transactionId',
					width: 100,
					renderCell: (params) => renderCopyableCell(params.value, { style: wrappedCopyableStyle })
				},
				{
					headerName: 'Upload Date',
					field: 'uploadDate',
					width: 100,
					valueGetter: ({ value }) => value || '',
					valueFormatter: ({ value }) => {
						if (!value) return '';
						const d = new Date(value);
						return new Intl.DateTimeFormat('en-US', { timeZone: 'UTC' }).format(d);
					},
					type: 'date',
					renderCell: (params) => renderCopyableCell(params.formattedValue || formatUtcDate(params.value))
				},
				{
					headerName: 'Modify Date',
					field: 'modifyDate',
					width: 100,
					valueGetter: ({ value }) => value || '',
					valueFormatter: ({ value }) => {
						if (!value) return '';
						const d = new Date(value);
						return new Intl.DateTimeFormat('en-US', { timeZone: 'UTC' }).format(d);
					},
					type: 'date',
					renderCell: (params) => renderCopyableCell(params.formattedValue || formatUtcDate(params.value))
				},
				{
					headerName: 'Posted Date',
					field: 'invoiceDocumentPostingUpdateDate',
					width: 100,
					valueGetter: ({ value }) => value || '',
					valueFormatter: ({ value }) => {
						if (!value) return '';
						const d = new Date(value);
						return new Intl.DateTimeFormat('en-US', { timeZone: 'UTC' }).format(d);
					},
					type: 'date',
					renderCell: (params) => renderCopyableCell(params.formattedValue || formatUtcDate(params.value))
				},
				{
					headerName: 'Archived',
					field: 'isArchive',
					renderCell: (props) => {
						const isArchived = props?.row?.isArchive === 'Y';
						const archiveLabel = isArchived ? 'Yes' : 'No';
						return (
							<CopyableCell value={archiveLabel} tooltipTitle={archiveLabel}>
								{isArchived ?
									<Check key={props?.row?.rowId} color={'action'} /> :
									<RemoveIcon key={props?.row?.rowId} color={'action'} />}
							</CopyableCell>

						)
					},
					valueGetter: (params) => params.row.isArchive || 'N',
					valueFormatter: (params) => params.value || 'N',
					type: 'singleSelect',
					valueOptions: [
						{ value: 'Y', label: 'Yes' },
						{ value: 'N', label: 'No' },
					],
					filterOperators: [
						{
							label: 'is',
							value: 'is',
							getApplyFilterFn: (filterItem) => {
								if (!filterItem.value) {
									return null;
								}
								return (params) => {
									return params.value === filterItem.value;
								};
							},
							InputComponent: ({ item, applyValue }) => {

								React.useEffect(() => {
									if (!item.value) {
										applyValue({ ...item, value: 'N' });
									}
								}, []);

								return (
									<FormControl fullWidth size="small" sx={{ mt: 0.4 }} variant="standard">
										<InputLabel id="archive-filter-label">Value</InputLabel>
										<Select
											labelId="archive-filter-label"
											value={item.value || ''}
											onChange={(e) => applyValue({ ...item, value: e.target.value })}
											label="Value"
											displayEmpty={false}
										>
											<MenuItem value="Y">Yes</MenuItem>
											<MenuItem value="N">No</MenuItem>
										</Select>
									</FormControl>
								);
							},
						},
					],
				},
				//{
				//	headerName: 'Actions',
				//	field: 'actions',
				//	align: 'center',
				//	headerAlign: 'center',
				//	renderCell: (rowData) => {
				//		const isLoading =
				//			this.state.loadingRowIds === rowData.row.invoiceDocumentId;

				//		if (isLoading) {
				//			return <CircularProgress size={18} />;
				//		}

				//		return this.displayActions(rowData.row);
				//	},
				//	//renderCell: rowData => this.displayActions(rowData.row),
				//	flex: 1
				//}
			);
			let filterMode = this.state.isServerMode ? { filterMode: 'server' } : {};


			// (Action column removed) — row click performs view; reload/spinner are in Status.

			const info = {
				rowData: this.state.rowData,
				invoiceDocumentId: this.state.rowData?.invoiceDocumentId,
				mode: this.state.mode,
				source: this.state.rowData?.invoiceSource,
				inProgress: this.props.inProgress,
				modelDefId: this.state.modelDefId,
				editorSource: 'VendorInvoicesReport',
				companyCode: this.state.rowData?.companyCode
			};

			const clientInfo = {
				rowData: this.state.rowData,
				mode: this.state.mode,
				modelDefId: this.state.modelDefId,
				inProgress: this.props.inProgress
			};

			return (
				<div>
					<h1>Vendor Invoices</h1>
					<style>{`
						.vendor-report-active-invoice { background-color: rgba(0, 140, 205, 0.15); }
						.vendor-report-active-invoice:hover { background-color: rgba(0, 140, 205, 0.22); }
							.vendor-report-refetching-row { 
								opacity: 0.55;
								cursor: not-allowed;
								filter: grayscale(0.25);
								background-color: rgba(0,0,0,0.03);
							}
							.vendor-report-refetching-row:hover { background-color: rgba(0,0,0,0.03); }
					`}</style>
					<div className="form-group">

						<div style={{ display: 'block', overflow: 'auto', width: '100%' }}>
							<EnhancedDataGrid rows={this.getFilteredRows()}
								rowHeight={51}
								columnHeaderHeight={40}
								disableColumnMenu
								pagination
								pageSize={10}
								columns={columns}
								quickFilterDebounceMs={1200}
								options={{
									pageSize: 10,
									pageSizeOptions: [10, 20, 30, 40, 50],
									maxBodyHeight: 670,
									filtering: true,
									columnsButton: true,
									exportButton: true,
									exportAllData: true,
									exportFileName: "VendorInvoices"
								}}
								filterMode="server"
								serverExport={false}
								gridRef={this.mainGridRef}
								showSearchButtonInToolbar={true}
								customFilterPanel={true}
								customcomponent={<>
									<StyledMultiSelect
										items={this.state.companyList}
										key="companyMultiSelect_1"
										defaultItems={[this.companyCode]}
										selectedItems={this.state.selectedCompanies.map(e => e.companyCode) || [this.companyCode]}
										callback={(data) => {
											let values = data;
											setFilter(['Reports', 'VendorInvoicesReport'], {
												...getFilter(['Reports', 'VendorInvoicesReport']),
												selectedCompanies: values
											});


											this.setState({
												...this.state,
												selectedCompanies: this.state.companyList.filter(e => values.indexOf(e.companyCode) > -1)
											})
										}}
										onCloseCallback={() => {
											this.fetchVendorInvoices({
												modelDefId: this.state.modelDefId,
												filterModel: this.state.filterModel,
												searchText: this.state.filterText,
												companiesList: this?.state?.selectedCompanies.map(e => e.companyCode)
											});
										}}
									/>
									<Select
										variant='standard'
										style={{ float: "right", zIndex: 1, marginTop: 2, marginRight: 10 }}
										value={this.state.modelDefId}
										onChange={this.modelDefId_changeHandler}
										sx={{
											backgroundColor: "rgba(0, 140, 205, 0.25)",
											"&.Mui-focused": {
												backgroundColor: "rgba(0, 140, 205, 0.25)",
											},
										}}
									>
										{this.getInvoiceTypeMenuItem(1, 'Media')}
										{this.getInvoiceTypeMenuItem(2, 'Production')}
										{this.getInvoiceTypeMenuItem(3, 'Broadcast')}
									</Select>

								</>}
								getRowId={(row) => row.rowId}
								disableSelectionOnClick
								getRowClassName={(params) => {
									const row = params?.row;
									const invoiceDocumentId = row?.invoiceDocumentId;
									const classes = [];

									// When a document is refetching, all its rows should LOOK disabled (including Post In Progress).
									if (invoiceDocumentId && this.isRowLoading(invoiceDocumentId)) {
										classes.push('vendor-report-refetching-row');
									}

									if (this.state.activeRowKey !== null && row?.rowId === this.state.activeRowKey) {
										classes.push('vendor-report-active-invoice');
									}

									return classes.join(' ');
								}}
								onRowClick={(params, event) => {
									const row = params?.row;
									if (!row) return;

									// Ignore clicks on interactive elements (links, buttons, checkboxes)
									const target = event?.target;
									const clickedInteractive =
										(target?.closest && (
											target.closest('a') ||
											target.closest('button') ||
											target.closest('input') ||
											target.closest('.MuiCheckbox-root') ||
											target.closest('.MuiDataGrid-checkboxInput')
										));
									if (clickedInteractive) return;

									const rowKey = row?.rowId;
									const invoiceId = row?.invoiceDocumentId;
									const isLoading = !!invoiceId && this.isRowLoading(invoiceId);
									if (isLoading) return; // disabled while refetching

									this.setState({ activeRowKey: rowKey ?? null, activeInvoiceDocumentId: invoiceId ?? null });
									this.detail_clickHandler(row);
								}}

								searchCallback={null}
								onFilterPanelSearch={(filterModel, quickFilterText) => {
									this.handleFilterPanelSearch(filterModel, quickFilterText);
								}}
								setFilterText={(text) => {

									const trimmedText = text?.trim() || '';
									const stored = getFilter(['Reports', 'VendorInvoicesReport']) || {};

									if (trimmedText === stored.filterText) return;

									const shouldResetSearch = stored.hasSearched && stored.filterText !== trimmedText;
									const nextHasSearched = shouldResetSearch ? false : stored.hasSearched;

									this.setState({
										...this.state,
										filterText: trimmedText,
										hasSearched: nextHasSearched
									});

									setFilter(['Reports', 'VendorInvoicesReport'], {
										...stored,
										filterText: trimmedText,
										hasSearched: nextHasSearched
									});
								}}
								highlightSearchTextOnMainScreenGrid={true}
								onColumnVisbilityModelChange={(model) => {
									this.setState({ columnVisibility: model });
									setFilter(['Reports', 'VendorInvoicesReport'], {
										...getFilter(['Reports', 'VendorInvoicesReport']),
										columnVisibility: model,
									});
								}}
								columnVisibilityModel={this.state.columnVisibility}
								onSortModelChange={(model) => {
									this.setState({ sortModel: model });
									setFilter(['Reports', 'VendorInvoicesReport', 'sortModel'], model);
								}}
								sortModel={this.state.sortModel}
								setFilterModel={(model) => {
									return null;
									//this.setState({
									//	filterModel: { items: [...model.items], logicOperator: model.logicOperator },
									//	isServerMode: !true // server mode = no user uploadDate
									//}, () => {

									//	this.mainGridRef.current?.setFilterModel({
									//		...model,
									//		quickFilterValues: [this.state.filterText]
									//	});
									//});
								}}
								customServerFilter={
									() => this.state.isServerMode ? () => { } : undefined
									//this.state.isServerMode
									//	? undefined
									//	: (searchModel) => this.fetchVendorInvoices(this.state.modelDefId, searchModel, this.state.filterText)

								}
								//	customServerFilter={(searchModel) => {
								//		this.fetchVendorInvoices(this.state.modelDefId, searchModel, this.state.filterText);
								//	}}
								exportServerCallback={() => {
									this.setState(prev => {
										return { ...prev, tempTableEnabled: true }
									}, () => {
										this.fetchVendorInvoices({
											modelDefId: this.state.modelDefId,
											filterModel: this.state.filterModel,
											searchText: this.state.filterText,
											companiesList: this?.state?.selectedCompanies.map(e => e.companyCode),
											exportData: true
										});
									})
								}}

								footerMessage={''}

							/>
						</div>
						{
							this.state.tempTableEnabled ?

								<ServerExportWrapper
									rows={this.state.exportData}
									initialState={{
										columns: {
											columnVisibilityModel: {
												...this.mainGridRef.current.exportState().columns.columnVisibilityModel
											},
										},
									}}
									columns={columns}
									options={{
										exportFileName: "VendorInvoices"
									}}
									dataLoaded={this.state.dataLoaded}
									getRowId={(row) => row.rowId}
									resetStates={() => {
										this.setState({
											...this.state,
											tempTableEnabled: false,
											dataLoaded: false,
											exportData: []
										})
									}}
								/>
								:
								<></>
						}
						{
							this.state.openInvoiceDocumentEditorDialog &&
							<Dialog open={this.state.openInvoiceDocumentEditorDialog} TransitionComponent={Transition} fullScreen>
								<InvoiceDocumentEditor info={info} clientInfo={clientInfo} onClose={this.invoiceDocumentEditor_closeHandler} fetchDashboard={(gadgetNo, weeks) => { }} />
							</Dialog>
						}

						<Dialog
							open={this.state.openCreditMemoRepostDialog}
							onClose={() => this.setState({ openCreditMemoRepostDialog: false, creditMemoRowForRepost: null, applyToInvoiceDocumentId: null })}
							TransitionComponent={Transition}
						>
							<DialogTitle>Rescan Original Invoice</DialogTitle>
							<DialogContent>
								<DialogContentText>
									Do you want to rescan the original invoice as well?
								</DialogContentText>
							</DialogContent>
							<DialogActions>

								<Button
									onClick={async () => {
										const row = this.state.creditMemoRowForRepost;
										const creditMemoId = row?.invoiceDocumentId;
										const companyCode = this.companyCode;
										const originalInvoiceId = this.state?.applyToInvoiceDocumentId;

										if (!creditMemoId) return;
										if (!creditMemoId) return;
										this.props.inProgress(true);
										try {
											if (originalInvoiceId > 0) {
												await httpPost("/api/invoicedocument/rescanoriginalinvoice", {
													companyCode: companyCode,
													modelDefId: this.state.modelDefId,
													applyToInvoiceDocumentId: originalInvoiceId
												});
												toast.success('Invoice sent for rescan');
											}
											this.setState({ openCreditMemoRepostDialog: false, creditMemoRowForRepost: null, applyToInvoiceDocumentId: null });
										}
										catch {
											toast.error('Rescaning invoice failed');
										}
										this.props.inProgress(false);
									}}
								>
									Yes
								</Button>
								<Button
									onClick={async () => {
										this.setState({ openCreditMemoRepostDialog: false, creditMemoRowForRepost: null, applyToInvoiceDocumentId: null });
									}}
								>
									Cancel
								</Button>
							</DialogActions>
						</Dialog>

					</div>
				</div>
			);
		}
}

function StyledMultiSelect({
	items = [],
	selectedItems = [],
	defaultItems = [],
	callback = (event) => { },
	onCloseCallback = () => { }, // Add new prop for the onClose event
}) {
	const [initialValues, setInitialValues] = React.useState([]);
	const menuItemOnChange = React.useCallback(
		(event) => {
			const { value } = event.target;
			let values = typeof value === "string" ? value.split(",") : value;
			if ((values || []).filter(e => e).length === 0) {
				values = defaultItems;
			}
			callback(values);
		},
		[callback, defaultItems]
	);
	const arrayEqual = (arr1, arr2) => {
		if (arr1.length != arr2.length)
			return false;
		let cond1 = arr1.every(e => arr2.indexOf(e) > -1);
		let cond2 = arr2.every(e => arr1.indexOf(e) > -1);
		return cond1 && cond2;
	}

	return (
		<Select
			multiple
			variant="standard"
			value={selectedItems}
			onChange={menuItemOnChange}
			onClose={() => {
				if (!arrayEqual(selectedItems, initialValues)) {
					onCloseCallback();
					setInitialValues([]);
				}
			}
			} // Add the onClose handler here
			onOpen={() => { setInitialValues(selectedItems) }}
			displayEmpty
			style={{
				float: "right",
				zIndex: 1,
				marginTop: 2,
				marginRight: 10,
			}}
			sx={{
				backgroundColor: "rgba(0, 140, 205, 0.25)",
				"&.Mui-focused": {
					backgroundColor: "rgba(0, 140, 205, 0.25)",
				},
				minWidth: 180,
			}}
			renderValue={(selected) => {
				if (selected.length === 0) return "Select Company";
				if (selected.length === 1) {
					const selectedItem = items.find((i) => i.companyCode === selected[0]);
					return selectedItem ? selectedItem.coName : "Select Company";
				}
				var names = items?.filter(e => selected.indexOf(e.companyCode) > -1)
					?.map(e => e.coName)?.join(", ");
				var rectified = (names.length > 20) ? names?.substring(0, 18)?.concat('...') : names;
				return rectified || "Multi Companies Selected";
			}}
		>
			{items.map((item) => (
				<MenuItem key={item.companyCode} value={item.companyCode}>
					<Checkbox checked={selectedItems.indexOf(item.companyCode) > -1} />
					<ListItemText primary={(defaultItems.indexOf(item.companyCode) > -1) ? `${item.coName}(default)` : item.coName} />
				</MenuItem>
			))}
		</Select>
	);
}